import { Component, Inject, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SubscriptionReportingListModel } from 'src/app/models/subscription-reporting/subscription-reporting-list-model';


@Component({
    selector: 'app-modal-delete-subscription-report',
    templateUrl: './modal-delete-subscription-report.component.html',
    styleUrls: ['./modal-delete-subscription-report.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ModalDeleteSubscriptionReportComponent  implements OnDestroy {

  loading = false;
  deleteSuccess: any;
  deleteError: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public sReport: SubscriptionReportingListModel
  ) { }

  ngOnDestroy(): void {
  }
}
